import { render } from "./InputGroup2.vue?vue&type=template&id=238c9892&scoped=true"
import script from "./InputGroup2.vue?vue&type=script&lang=js"
export * from "./InputGroup2.vue?vue&type=script&lang=js"

import "./InputGroup2.vue?vue&type=style&index=0&id=238c9892&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238c9892"]])

export default __exports__